import {actionTypes} from "./actionTypes";

export const toggleWinMessageUpdateModal=({id,message})=>{
    return {
        type:actionTypes.TOGGLE_UPDATE_WIN_MESSAGE_MODAL,
        payload:{id,message}
    }
}